import { Card, Spinner, Text } from '@chakra-ui/react'

const LoadingPage = () => {

    return (
        <div>
            <Card align='center' p={5}>
            <Spinner
                    thickness='4px'
                    speed='0.65s'
                />
                <Text>La pagina esta cargando, en unos momentos podra continuar tranquilamente</Text>
            </Card>
        </div>
    )
}

export default LoadingPage